import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center space-y-12"
        >
          {/* Mission Statement */}
          <div className="space-y-6">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.8 }}
              viewport={{ once: true }}
              className="text-4xl md:text-5xl font-bold"
            >
              Building transformational tech for{' '}
              <span className="gradient-text">exponential people</span>
            </motion.h2>
            
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              viewport={{ once: true }}
              className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed"
            >
              We believe that the right technology can unlock human potential at unprecedented scales. 
              Our AI-powered platforms don't just optimize processes—they transform how individuals 
              and organizations evolve.
            </motion.p>
          </div>

          {/* Visual Elements */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.6, duration: 1 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="flex justify-center items-center space-x-8 md:space-x-16">
              {/* Data Flow Visualization */}
              <div className="flex flex-col items-center space-y-4">
                {[1, 2, 3].map((i) => (
                  <motion.div
                    key={i}
                    animate={{ 
                      scale: [1, 1.2, 1],
                      opacity: [0.5, 1, 0.5]
                    }}
                    transition={{ 
                      duration: 2,
                      repeat: Infinity,
                      delay: i * 0.3
                    }}
                    className="w-3 h-3 bg-primary-orange rounded-full"
                  ></motion.div>
                ))}
              </div>

              {/* Central Hub */}
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                className="w-32 h-32 border-2 border-primary-orange rounded-full flex items-center justify-center relative"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-primary-orange to-primary-dark rounded-full flex items-center justify-center">
                  <span className="text-black font-bold text-xl">AI</span>
                </div>
                
                {/* Orbiting Elements */}
                {[0, 120, 240].map((rotation, i) => (
                  <motion.div
                    key={i}
                    animate={{ rotate: -360 }}
                    transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                    className="absolute w-6 h-6 bg-primary-orange rounded-full"
                    style={{
                      transformOrigin: '0 0',
                      transform: `rotate(${rotation}deg) translateX(60px)`,
                    }}
                  ></motion.div>
                ))}
              </motion.div>

              {/* Data Flow Visualization */}
              <div className="flex flex-col items-center space-y-4">
                {[1, 2, 3].map((i) => (
                  <motion.div
                    key={i}
                    animate={{ 
                      scale: [1, 1.2, 1],
                      opacity: [0.5, 1, 0.5]
                    }}
                    transition={{ 
                      duration: 2,
                      repeat: Infinity,
                      delay: (i * 0.3) + 1
                    }}
                    className="w-3 h-3 bg-primary-orange rounded-full"
                  ></motion.div>
                ))}
              </div>
            </div>

            {/* Connecting Lines */}
            <motion.div
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              transition={{ delay: 1, duration: 1 }}
              viewport={{ once: true }}
              className="absolute top-1/2 left-0 right-0 h-px bg-gradient-to-r from-primary-orange via-transparent to-primary-orange transform -translate-y-1/2"
            ></motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;